import { H2 } from "@blueprintjs/core";
import { setCurrentRoute, setPreviousRoute } from "controllers/common/action";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { constructPath, findRoute, routes } from "routes";
import { Analytics } from "utils/analytics";
import route from "./route";

export default function ConferencePapers() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentRoute(route));
    Analytics.getInstance().pageview(constructPath(findRoute(routes, route.id)));
    return () => dispatch(setPreviousRoute(route));
  });
  return (
    <div className="publications">
      <H2>Conference Papers</H2>
      <ol>
        <li id="ref-MaK20_co_opt" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TD39804.2020.9299658" target="_blank" rel="noreferrer">
            K. Ma, D. Wang, J. Lian, D. Wu, and S. Katipamula, “Market-based co-optimization of energy and ancillary
            services with distributed energy resource flexibilities,” in{" "}
            <cite>
              Proceedings of the IEEE Power and Energy Society Transmission and Distribution Conference and Exposition
            </cite>
            , Oct. 2020, pp. 1–5.
          </a>
        </li>
        <li id="ref-WuD20_performance" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM41954.2020.9282053" target="_blank" rel="noreferrer">
            D. Wu, P. Balducci, A. Crawford, K. Mongird, and X. Ma, “Building battery energy storage system performance
            data into an economic assessment,” in{" "}
            <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, Aug. 2020, pp. 1–5.
          </a>
        </li>
        <li id="ref-Das20" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM41954.2020.9281629" target="_blank" rel="noreferrer">
            A. Das, Z. Ni, X. Zhong, and D. Wu, “Experimental validation of approximate dynamic programming based
            optimization and convergence on microgrid applications,” in{" "}
            <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, Aug. 2020, pp. 1–5.
          </a>
        </li>
        <li id="ref-WuD20_IFAC" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1016/j.ifacol.2020.12.167" target="_blank" rel="noreferrer">
            D. Wu, P. Wang, X. Ma, and K. Kalsi, “Scheduling and control of flexible building loads for grid services
            based on a virtual battery model,” in <cite>21th IFAC World Congress</cite>, vol. 53, no. 2, Apr. 2020, pp.
            13 333–13 338.
          </a>
        </li>
        <li id="ref-WangP19_GM" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM40551.2019.8973442" target="_blank" rel="noreferrer">
            P. Wang, D. Wu, and J. Wang, “Impacts of lock-off time on virtual battery model from thermostatically
            controlled loads,” in <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, 2019.
          </a>
        </li>
        <li id="ref-WangJ19_GM" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM40551.2019.8973486" target="_blank" rel="noreferrer">
            J. Wang, S. Huang, D. Wu, and N. Lu,, “A data-driven control method for operating the commercial HVAC load
            as a virtual battery,” in
            <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, 2019.
          </a>
        </li>
        <li id="ref-WuD18EVSE" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2018.8586401" target="_blank" rel="noreferrer">
            D. Wu, X. Ke, N. Radhakrishnan, and A. Reiman, “Optimization methods for evaluating PEV charging considering
            customer behavior,” in <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>,
            Portland, OR, Aug. 5–9, 2018.
          </a>
        </li>
        <li id="ref-WangP18_communication" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/CDC.2018.8619387" target="_blank" rel="noreferrer">
            P. Wang, Y. Gao, N. Yu, W. Ren, J. Lian, and D. Wu, “Communication-efficient distributed solutions to a
            system of linear equations with Laplacian sparse structure,” in{" "}
            <cite>Proceedings of the IEEE Conference on Decision and Control</cite>, Miami Beach, FL, Dec. 2018, pp.
            3367–3372.
          </a>
        </li>
        <li id="ref-DuW18" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2018.8586094" target="_blank" rel="noreferrer">
            W. Du, L. Yao, D. Wu, X. Li, G. Liu, and T. Yang, “Accelerated distributed energy management for
            microgrids,” in <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, Aug. 2018,
            pp. 1–5.
          </a>
        </li>
        <li id="ref-WuD18_VB_regional" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/TDC.2018.8440225" target="_blank" rel="noreferrer">
            D. Wu, H. Hao, T. Fu, and K. Kalsi, “Regional assessment of virtual battery potential from building loads,”
            in{" "}
            <cite>
              Proceedings of the IEEE Power and Energy Society Transmission and Distribution Conference and Exposition
            </cite>
            , Apr. 2018, pp. 1–5.
          </a>
        </li>
        <li id="ref-Yang17CDC" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/CDC.2017.8264614" target="_blank" rel="noreferrer">
            T. Yang, D. Wu, W. Ren, H. Wang, Y. Hong, and K. H. Johansson, “Cooperative optimal coordination for
            distributed energy resources,” in <cite>Proceedings of the IEEE Conference on Decision and Control</cite>,
            2017, pp. 6334–6339.
          </a>
        </li>
        <li id="ref-LianJ_Framework_GM17" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2017.8274331" target="_blank" rel="noreferrer">
            J. Lian, D. Wu, H. Chen, and K. Kalsi, “Theoretical framework for integrating distributed energy resources
            into distribution systems,” in
            <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, 2017, pp. 1–5.
          </a>
        </li>
        <li id="ref-WuD17_EESAT" className="csl-entry" role="doc-biblioentry">
          <a
            href="https://www.pnnl.gov/publications/optimal-control-battery-storage-using-nonlinear-models"
            target="_blank"
            rel="noreferrer"
          >
            D. Wu, P. J. Balducci, A. J. Crawford, V. V. Viswanathan, and M. C. W. Kintner-Meyer, “Optimal control for
            battery storage using nonlinear models,” in{" "}
            <cite>Electrical Energy Storage Applications and Technologies</cite>, San Diego, CA, Oct. 2017.
          </a>
        </li>
        <li id="ref-FangH16_cdc" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/CDC.2016.7798911" target="_blank" rel="noreferrer">
            H. Fang, D. Wu, and T. Yang, “Cooperative management of a lithium-ion battery energy storage network: A
            distributed MPC approach,” in
            <cite>Proceedings of the IEEE Conference on Decision and Control</cite>, no. 4226-4232, Las Vegas, NV, Dec.
            2016.
          </a>
        </li>
        <li id="ref-YangT16_distStor" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2016.7741778" target="_blank" rel="noreferrer">
            T. Yang, D. Wu, A. Stoorvogel, and J. Stoustrup, “Distributed coordination of energy storage with
            distributed generators,” in <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>,
            Boston, MA, Jul. 2016, pp. 1–5.
          </a>
        </li>
        <li id="ref-WuD16_behindmeter" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2016.7741210" target="_blank" rel="noreferrer">
            D. Wu, M. Kintner-Meyer, T. Yang, and P. Balducci, “Economic analysis and optimal sizing for
            behind-the-meter battery storage,” in
            <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, Boston, MA, Jul. 2016, pp.
            1–5.
          </a>
        </li>
        <li id="ref-YangT15_gm" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2015.7286216" target="_blank" rel="noreferrer">
            T. Yang, D. Wu, Y. Sun, and J. Lian, “Impacts of time delays on distributed algorithms for economic
            dispatch,” in <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, Denver, CO,
            Jul. 2015, pp. 1–5.
          </a>
        </li>
        <li id="ref-WuD15_gm" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/PESGM.2015.7285820" target="_blank" rel="noreferrer">
            D. Wu, C. Jin, P. Balducci, M. Kintner-Meyer, “An energy storage assessment: Using optimal control
            strategies to capture multiple services,” in
            <cite>Proceedings of the IEEE Power and Energy Society General Meeting</cite>, Denver, CO, Jul. 2015, pp.
            1–5.
          </a>
        </li>

        <li id="ref-WuD08_energy2030" className="csl-entry" role="doc-biblioentry">
          <a href="http://dx.doi.org/10.1109/ENERGY.2008.4781038" target="_blank" rel="noreferrer">
            D. Wu, H. Chen, T. Das, and D. C. Aliprantis, “Bidirectional power transfer between HEVs and grid without
            external power converters,” in
            <cite>Proceedings of the IEEE 2030 Conference</cite>, Atlanta, GA, Nov. 17–18, 2008.
          </a>
        </li>
      </ol>
    </div>
  );
}
// const mapStateToProps = (state: any) => ({});

// const mapActionToProps = { setCurrentRoute };

// export default connect(mapStateToProps, mapActionToProps)(ConferencePapers);
